import { ApiGenericResponse } from "../ApiGenericResponse";
import { AxiosResponse } from "axios";
import { InstallationCaosUserSyncConfiguration } from "@/model/data/caosConfiguration/InstallationCaosUserSyncConfiguration";

export class FetchInstallationsCaosUserSyncConfigurationResData extends ApiGenericResponse {
    installationsList: InstallationCaosUserSyncConfiguration[];
    totalInstallationsCount: number;

    constructor(response: AxiosResponse) {
        super(response);
        if (response.data && response.data.Payload) {
            this.parse(response.data.Payload);
        }
    }

    public parse(obj: any) {
        if (obj.InstallationsList) {
            this.installationsList = new Array<InstallationCaosUserSyncConfiguration>();
            obj.InstallationsList.forEach((element) => {
                let c = new InstallationCaosUserSyncConfiguration();
                c.parse(element);
                this.installationsList.push(c);
            });
        }

        if (obj.TotalInstallationsCount != null && obj.TotalInstallationsCount != undefined) this.totalInstallationsCount = obj.TotalInstallationsCount;
    }
}
